import(/* webpackMode: "eager" */ "/codebuild/output/src703189256/src/pixelated-tech/apps/brianwhaley/src/app/global-error.tsx");
